import { c as _c } from "react/compiler-runtime";
import { ComponentProps, PropsWithChildren } from 'react';
import { DialogContent as DialogContentLib } from '@material-bank/mb3-components';
type DialogContentProps = ComponentProps<typeof DialogContentLib> & {
  hideCloseButton?: boolean;
};
export function DialogContent(t0) {
  const $ = _c(9);
  let children;
  let className;
  let hideCloseButton;
  let rest;
  if ($[0] !== t0) {
    ({
      children,
      className,
      hideCloseButton,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = hideCloseButton;
    $[4] = rest;
  } else {
    children = $[1];
    className = $[2];
    hideCloseButton = $[3];
    rest = $[4];
  }
  const closeButtonHidden = hideCloseButton ? " [&>button.absolute]:hidden" : "";
  const mergedClassName = className ? `${"max-w-[90%] max-h-[90%] min-h-[348px] md:max-w-[680px] lg:max-w-[800px] overflow-y-auto bg-white rounded-4xl"}${closeButtonHidden} ${className}` : `${"max-w-[90%] max-h-[90%] min-h-[348px] md:max-w-[680px] lg:max-w-[800px] overflow-y-auto bg-white rounded-4xl"}${closeButtonHidden}`;
  let t1;
  if ($[5] !== children || $[6] !== mergedClassName || $[7] !== rest) {
    t1 = <DialogContentLib className={mergedClassName} {...rest}>{children}</DialogContentLib>;
    $[5] = children;
    $[6] = mergedClassName;
    $[7] = rest;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  return t1;
}